import React, { Component, useEffect, useState } from "react";

// Mui
import { Box, Tooltip as TooltipMUI } from "@mui/material";

// Jds
import {
  BadgeV2,
  Container,
  DropdownMenuGroup,
  DropdownMenuItem,
  Image,
  Text,
  Tooltip,
} from "@jds/core";

// Local
import CardOverlay from "../Cards/CardOverlay";
import KebabButton from "../Buttons/KebabButton";
import JdsMenu from "../JdsMenu";
import decryptUrl from "../../../util/img-decryption";
//img
import premium from "../../../assets/png/premium.png";
import { addParamsURL } from "../../../util/helper";
import { useSelector } from "react-redux";
export default function AlbumCard({
  data,
  onClick,
  setEditData = () => {},
  setEditModalClose = () => {},
  setDeleteModalClose = () => {},
  setDeleteThumbnailModalClose = () => {},
  setSwitchFolderPublicConfirmationModalClose = () => {},
  setIsPublic = () => {},
  photograherTab = false,
  setPhotographerAccessModalClose = () => {},
  setApproveModalClose = () => {},
}) {
  const { eventDetails } = useSelector((state) => state.eventDetails);
  const isAdmin = eventDetails?.userRole == "ADMIN";

  return (
    <Box
      width={184}
      height={184}
      borderRadius={6}
      position="relative"
      onClick={onClick}
      sx={{ overflow: "hidden", cursor: "pointer" }}
    >
      <CardOverlay />
      {/* <Image aspectRatio="1:1" src={data?.thumbnailImage || ""} /> */}
      <Image
        aspectRatio="1:1"
        src={
          addParamsURL(decryptUrl(data?.thumbnailImage), { size: "s" }) || ""
        }
      />
      {data?.isPublic && isAdmin && (
        <Box
          sx={{
            position: "absolute",
            top: "16px",
            left: "16px",
            zIndex: 2,
          }}
        >
          <BadgeV2 label="Public" informationKind="label" size="xtra-large" />
        </Box>
      )}
      {data?.photographerFolderImagesCounts?.disapproveCount && (
        <Box
          sx={{
            position: "absolute",
            top: "16px",
            left: "16px",
            zIndex: 2,
          }}
        >
          <TooltipMUI title={"Pending for Approval"} position="bottom" arrow>
            <span
              style={{
                backgroundColor: "var(--color-feedback-error-50)",
                fontSize: "12px",
                fontWeight: "700",
                color: "#ffff",
                padding: "4px 8px",
                borderRadius: "4px",
              }}
            >
              {data?.photographerFolderImagesCounts?.disapproveCount}
            </span>
          </TooltipMUI>
        </Box>
      )}
      <Box
        sx={{
          position: "absolute",
          // top: "16px",
          bottom: "16px",
          left: "16px",
          zIndex: 2,
          maxWidth: "calc(100% - 32px)",
          backgroundColor: "#000",
          padding: "1px 4px",
          borderRadius: "4px",
        }}
      >
        {/* <BadgeV2
          label={data?.name || "Folder Name"}
          size="small"
          kind="information"
          informationKind="label"
          color="neutral"
        /> */}
        {/* <Text
          text={data?.name || "Folder Name"}
          color="white"
          appearance="body_xs"
          maxLines={1}
        /> */}
        <Tooltip label={data?.name || "Folder Name"} position="bottom">
          <p
            style={{
              color: "white",
              fontSize: "var(--font-sizes-body-xs)",
              textWrap: "nowrap",
              textOverflow: "ellipsis",
              overflow: "hidden",
              maxWidth: "152px",
            }}
          >
            {data?.name || "Folder Name"}
          </p>
        </Tooltip>
      </Box>
      <Container
        direction="column"
        verticalAlign="end"
        style={{
          position: "absolute",
          bottom: "16px",
          left: "16px",
          zIndex: 2,
        }}
        gap={4}
      >
        {/* <Text text={data.date || "Date"} appearance="body-xs" color="white" /> */}
        {/* <Text text={data.time || "Time"} appearance="body-xs" color="white" /> */}
      </Container>
      {/* {data?.isPremium && (
        <Box
          sx={{ position: "absolute", top: "16px", left: "16px", zIndex: 2 }}
        >
          <img src={premium} alt="" style={{ width: "32px" }} />
        </Box>
      )} */}
      {isAdmin && (
        <Box
          sx={{ position: "absolute", top: "16px", right: "16px", zIndex: 2 }}
        >
          <JdsMenu
            trigger={{
              component: KebabButton,
            }}
          >
            <DropdownMenuGroup hideBottomDivider>
              {photograherTab && (
                <DropdownMenuItem
                  prefix={"IcCamera"}
                  label="Select Photographer Access"
                  onClick={() => {
                    setPhotographerAccessModalClose(false);
                    setEditData(data);
                  }}
                />
              )}{" "}
              {photograherTab && (
                <DropdownMenuItem
                  prefix={"IcFolder"}
                  label="Approve Folder"
                  onClick={() => {
                    setApproveModalClose(false);
                    setEditData(data);
                  }}
                />
              )}
              <DropdownMenuItem
                prefix={"IcEditPen"}
                label="Edit"
                value="edit"
                onClick={() => {
                  setEditModalClose(false);
                  setEditData(data);
                }}
              />
              <DropdownMenuItem
                prefix={"IcTrash"}
                label="Delete"
                value="delete"
                onClick={() => {
                  setDeleteModalClose(false);
                  setEditData(data);
                }}
              />
              {/* {isAdmin && <DropdownMenuItem
                prefix={"IcGroup"}
                label="Switch Public"
                value="public"
                onClick={() => {
                  setSwitchFolderPublicConfirmationModalClose(false)
                  setEditData(data);
                  setIsPublic(data?.isPublic)
                }}
              >
              </DropdownMenuItem>} */}
              {data?.thumbnailImage ? (
                <DropdownMenuItem
                  prefix={"IcPhotoRemove"}
                  label="Remove Thumbnail"
                  onClick={() => {
                    setDeleteThumbnailModalClose(false);
                    setEditData(data);
                  }}
                />
              ) : (
                ""
              )}
              {/* <DropdownMenuItem prefix={"IcShare"} label="Share" value="share" /> */}
            </DropdownMenuGroup>
          </JdsMenu>
        </Box>
      )}
    </Box>
  );
}
